var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGift({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 114,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#dd7403",
    d: "M99.5 54.134H8.277v85.316H99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b76009",
    d: "M99.5 28.053H8.277v34.77H99.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f4ae00",
    d: "M107.777 28.053H0v26.074h107.777z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc0029",
    d: "M57.857 28.053H49.92V139.45h7.937z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc0029",
    d: "M51.324 27.485c-.653.105-15.026 17.685-15.026 17.685l8.14 3.404 8.14-19.495zm6.546 0c.654.105 15.027 17.685 15.027 17.685l-8.14 3.404-8.14-19.495zm-4.612-2.568C53.258 23.951 76.078 0 76.078 0l9.656 16.803L55.8 26.466z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc0029",
    d: "M54.519 24.917C54.486 23.951 31.699 0 31.699 0l-9.663 16.803 29.941 9.663z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#bc0029",
    d: "M53.885 32.019a3.966 3.966 0 1 0 0-7.931 3.966 3.966 0 0 0 0 7.93z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h107.777v139.45H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGift);
export default __webpack_public_path__ + "static/media/gift.287b2dc2386d2ccd16770373f8b1ce8f.svg";
export { ForwardRef as ReactComponent };